import { Alert, Spinner, Stack, useToast } from '@ui';
import { useTranslation } from 'react-i18next';
import { errorMessage } from '../../../lib/errors';
import { useBusiness } from '../api';
import { BusinessProfileForm } from '../components/BusinessProfileForm';
import { useSession } from '../session';

/** Master data and region of the business (BIZ-002, BIZ-003). */
export function BusinessSettingsPage() {
  const { t } = useTranslation();
  const toast = useToast();
  const { can } = useSession();
  const query = useBusiness();

  if (!query.data) {
    return query.error ? (
      <Alert tone="danger">{errorMessage(query.error)}</Alert>
    ) : (
      <Spinner label={t('common.loading')} />
    );
  }
  const data = query.data;
  const canEdit = can('business.write');

  return (
    <Stack gap={6}>
      {!canEdit && <Alert tone="info">{t('common.readOnlyPermission')}</Alert>}
      <BusinessProfileForm
        business={data}
        sections={['basics', 'address', 'contact', 'official', 'bank', 'region']}
        readOnly={!canEdit}
        onSaved={() => toast.show(t('common.saved'))}
      />
    </Stack>
  );
}
